import React, { useEffect, useMemo } from 'react';
import { useTranslations, usePaymentPlans } from "examsbook-react-sdk/custom-hooks";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useNavigate } from "react-router-dom";
import {
    FailedTransactionModel,
    CouponAppliedModel,
    ApplyCouponModel,
    PaymentSuccessView,
    PlanSelectionView,
    PlanConfirmationView
} from "../components/Checkout";
import { isCouponValid } from "examsbook-react-sdk/services/paymentPlanService";

function Payments(props) {
    const { failed, transactionDetails } = props;
    const t = useTranslations();
    const navigate = useNavigate();
    const { plans, coupons } = usePaymentPlans();
    const [ selectedPlanId, setSelectedPlanId ] = React.useState('');
    const [ open, setOpen ] = React.useState(false);
    const [ coupon, setCoupon ] = React.useState(false);
    const [ payments, setPayments ] = React.useState(false);
    const [ paymentSuccess, setPaymentSuccess ] = React.useState(false);
    const [ appliedCoupon, setAppliedCoupon ] = React.useState('');
    const [ isFailedTransactionModelOpen, setFailedTransactionModelOpen ] = React.useState(false);
    useEffect(() => {
        if (failed) {
            setFailedTransactionModelOpen(!!failed);
        }
    }, [ failed ]);
    const failedTransactionModalOpen = () => {
        setFailedTransactionModelOpen(true);
    };
    const failedTransactionModalClose = () => {
        setFailedTransactionModelOpen(false);
    };

    const applyCouponFn = async (couponCode, selectedPlanId) => {
        // call service and validate if coupon is valid.
        const apiResponse = await isCouponValid(couponCode, selectedPlanId);
        const isValid = apiResponse.valid;
        if (isValid) {
            setAppliedCoupon(couponCode);
            setCoupon(true);
            setOpen(false);
        } else {
            setCoupon(true);
            setOpen(false);
        }
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const couponAppliedModalClose = () => {
        setCoupon(false);
    };
    const filteredCoupons = coupons ? coupons.filter((coupon) => coupon.couponCode === appliedCoupon) : [];
    const selectedCoupon = filteredCoupons && filteredCoupons.length ? filteredCoupons[0] : {};

    const makePayment = () => {
        setPayments(true);
    };

    function goToDashboard() {
        navigate('/my-app');
    }

    function getDays(subscriptionType) {
        let days = 0;
        if (subscriptionType === 'MONTHLY') {
            days = 30;
        } else if (subscriptionType === 'QUARTERLY') {
            days = 90;
        } else if (subscriptionType === 'HALFYEARLY') {
            days = 180;
        } else if (subscriptionType === 'YEARLY') {
            days = 365;
        }
        return days;
    }

    function planCardClick(plan) {
        setSelectedPlanId(plan._id);
        //clear any previous applied coupon
        setAppliedCoupon({});
    }

    let calculatedPlans = useMemo(() => {
        return plans.map((plan) => {
            let actualPrice = plan.actualPrice;
            let discountBeforeCoupon = actualPrice - plan.price;
            let discountViaCoupon = 0;
            if (selectedCoupon && selectedCoupon.plan && selectedCoupon.plan.filter((p) => p._id === plan._id).length && selectedPlanId === plan._id) {
                discountViaCoupon = Math.min(Math.floor((selectedCoupon.discount * plan.price) / 100), selectedCoupon.maxAmount);
            }
            let totalDiscount = discountBeforeCoupon + discountViaCoupon;
            let calculatedPlan = {
                ...plan,
                days: getDays(plan.subscriptionType),
                actualPrice: plan.actualPrice,
                cashDiscount: totalDiscount,
                discountViaCoupon: discountViaCoupon,
                finalPrice: actualPrice - totalDiscount,
                discount: selectedCoupon?.discount
            };
            return calculatedPlan;
        });
    }, [ plans, selectedCoupon, selectedPlanId ]);
    useEffect(() => {
        if (!selectedPlanId) {
            let recommendedPlan = calculatedPlans.find((plan) => plan.isRecommended);
            if (recommendedPlan) {
                setSelectedPlanId(recommendedPlan._id);
            }
        }
    }, [ calculatedPlans, selectedPlanId ]);
    const selectedPlan = calculatedPlans.find((plan) => plan._id === selectedPlanId);
    let paymentAction;
    if (selectedPlan) {
        paymentAction = "/api/v1/initiate/payment/web/" + selectedPlan.subscriptionId;
        if (selectedCoupon && selectedCoupon.couponCode && selectedPlan) {
            paymentAction = paymentAction + '?code=' + selectedCoupon.couponCode;
        }
    }
    return (
        <div>
            <div>
                <div className="mobile-back-to-test">
                    <ArrowBackIcon onClick={goToDashboard}/>
                    <span>{t('Checkout')}</span>
                </div>

                {!paymentSuccess ?
                    <>
                        {!payments ?
                            <PlanSelectionView
                                selectedCoupon={selectedCoupon}
                                calculatedPlans={calculatedPlans}
                                getDays={getDays}
                                planCardClick={planCardClick}
                                selectedPlan={selectedPlan}
                                removeCoupon={() => {
                                    setAppliedCoupon({});
                                }}
                                makePayment={makePayment}
                                handleOpen={handleOpen}/>
                            :
                            <PlanConfirmationView
                                selectedPlan={selectedPlan}
                                getDays={getDays}
                                handleOpen={handleOpen}
                                paymentAction={paymentAction}
                                selectedCoupon={selectedCoupon}
                                removeCoupon={() => {
                                    setAppliedCoupon({});
                                }}
                                failedTransactionModalOpen={failedTransactionModalOpen}/>
                        }
                    </>
                    :
                    <PaymentSuccessView/>
                }
            </div>
            <ApplyCouponModel isOpen={open} closeModel={handleClose} selectedPlanId={selectedPlanId} coupons={coupons}
                              applyCouponFn={applyCouponFn}/>
            <CouponAppliedModel isOpen={coupon} selectedPlan={selectedPlan} selectedCoupon={selectedCoupon}
                                closeModel={couponAppliedModalClose}/>
            {
                failed && <FailedTransactionModel
                    transactionDetails={transactionDetails}
                    isOpen={isFailedTransactionModelOpen}
                    getDays={getDays}
                    closeModel={failedTransactionModalClose}/>
            }
        </div>
    );
}

export default Payments;
